import type { IconKey } from 'components/ui/icon'
import useScript from '@disco/utils/use-script'
export type AbortProviderOpen = () => void
type OpenProviderFunction = (
  onPicked: (files: any[]) => void,
) => AbortProviderOpen
type ProviderConfig = Record<
  string,
  {
    icon: IconKey
    color?: string
    open?: OpenProviderFunction
    // Optional loader component
    loader?: () => React.ReactNode
  }
>

const openProviderPicker = (
  providerId: string,
  onPicked: (files: any[]) => void,
) => {
  const picker = window.open(
    `/upload-api/external_upload/${providerId}/picker/`,
    providerId,
    'width=800,height=600,toolbar=no,menubar=no,location=no,status=no',
  )

  const cleanup = () => {
    window.removeEventListener('message', messageListener)
    if (checkPopupClosed) clearInterval(checkPopupClosed)
  }

  const messageListener = event => {
    // Validate the origin and source of the message
    if (event.origin !== window.origin) return
    if (event.source !== picker) return

    if (event.data?.name === 'content-picker/files-selection') {
      onPicked(event.data.files) // Callback to handle the selected files

      cleanup() // Perform cleanup after picking files
    }
  }

  window.addEventListener('message', messageListener)
  // Periodically check if the popup is closed
  const checkPopupClosed = setInterval(() => {
    if (picker?.closed) cleanup()
  }, 500)
  // Check every 500ms
  return picker
}

const DropboxLoader: () => React.ReactNode = () => {
  useScript(`https://www.dropbox.com/static/api/2/dropins.js`, {
    id: 'dropboxjs',
    'data-app-key': DROPBOX_APP_KEY,
  })
  return null
}

const providerConfig: ProviderConfig = {
  dropbox: {
    icon: 'dropbox',
    color: '#0061ff',

    open(onPicked) {
      if (!window.Dropbox) return
      window.Dropbox.choose({
        linkType: 'preview',
        multiselect: true,
        // can't be used with linkType "direct"
        // https://www.dropbox.com/developers/chooser
        // folderselect: true,
        success: files => {
          console.log('picked files: ', files)
          onPicked(files)
        },
      })
      return window.Dropbox.cancelChooser
    },

    loader: DropboxLoader,
  },
  box: {
    icon: 'box',
    color: '#0061D5',

    open(onPicked) {
      const boxWindow = openProviderPicker('box', onPicked)
      return () => {
        boxWindow?.close()
      }
    },
  },
}
export default providerConfig
